import * as React from "react"
import {observer} from "mobx-react"
import * as MDC from "@cling/lib.web.mdc"
import {i18n} from "@cling/lib.web.i18n"
import {upload_state, ui_state} from "../state/index"
import {classNames} from "@cling/lib.web.utils"
import {running_on_mobile_device} from "@cling/lib.web.utils"
import {runInAction} from "mobx"

export const UploadProgressToast = observer(() => {
    const cancel_uploads = React.useCallback(() => {
        upload_state.cancel_uploads()
    }, [])
    const ref = React.useCallback((elm?: ReactRef<HTMLDivElement>) => {
        runInAction(() => {
            ui_state.toast_shown = !!elm
        })
    }, [])
    const {
        num_files_total,
        num_files_uploaded,
        num_bytes_total,
        num_bytes_uploaded_of_uploaded_files,
        num_bytes_uploaded_of_uploading_file,
        name_of_uploading_file,
    } = upload_state
    if (num_files_uploaded === num_files_total) {
        return null
    }
    const num_bytes_uploaded =
        num_bytes_uploaded_of_uploaded_files + num_bytes_uploaded_of_uploading_file
    return (
        <div
            className={classNames("toast", {
                "toast--with-bottom-app-bar": running_on_mobile_device() && ui_state.app_bar_shown,
            })}
            ref={ref}
            data-test-id="UploadProgressToast"
        >
            <span className="toast__text">
                {i18n.uploading(num_files_uploaded, num_files_total, name_of_uploading_file)}
            </span>
            <progress
                className="toast__progress_bar"
                value={num_bytes_uploaded}
                max={num_bytes_total}
            />
            <div className="toast__action">
                <MDC.Button onClick={cancel_uploads}>{i18n.cancel}</MDC.Button>
            </div>
        </div>
    )
})
